import { render, staticRenderFns } from "./sidebar_menu.vue?vue&type=template&id=6b87ddd7"
import script from "./sidebar_menu.vue?vue&type=script&lang=js"
export * from "./sidebar_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports